import type { ReactNode } from 'react';

import type { CreatedPayoutDraftData } from 'api';

import { DraftDefinitionProvider } from './DraftDefinitionProvider';
import { DraftProgressProvider } from './DraftProgressProvider';
import { DraftStepSubmitBusProvider } from './DraftStepSubmitBus';

type DraftProvidersProps = {
  children: ReactNode;
  fieldDefinitions: CreatedPayoutDraftData;
};

export const DraftProviders = ({
  children,
  fieldDefinitions
}: DraftProvidersProps) => {
  return (
    <DraftDefinitionProvider fieldDefinitions={fieldDefinitions}>
      <DraftProgressProvider draftId={fieldDefinitions.draft_id}>
        <DraftStepSubmitBusProvider>{children}</DraftStepSubmitBusProvider>
      </DraftProgressProvider>
    </DraftDefinitionProvider>
  );
};
